import Switch from 'components/switch/switch';

export default Switch;
